import { useEffect, useState } from "preact/hooks";
import { PaymentGateway } from "../../../../services/payment-gateway";
import Config from "../../config";
import { shouldAskTelegram, TelegramButton } from "../../../../services/telegram/openidLogin";
import { t } from "@lingui/core/macro";

export function useP2PIframe(defaultPage: "offers"|"my-purchases"|"withdraw"|"my-offers") {
    const [api] = useState(() => new PaymentGateway(Config.softionAPI));
    const [link, setLink] = useState<string>(null)
    const [error, setError] = useState<string>(null)
    useEffect(() => {
        api.getP2PIframe(defaultPage).then(data => setLink(data.iframe)).catch(setError);
    }, []);
    return {
        link, 
        error
    };
}

export function P2PPage({defaultPage}: {defaultPage: "offers"|"my-purchases"|"withdraw"|"my-offers"}) {
    const requestNotifications = shouldAskTelegram();

    if (requestNotifications) {
        return <div class="h-full w-full min-h-[inherit] flex items-center justify-center">
            <TelegramButton
                clientId={Config.telegramLogin}
                onError={console.error}
                onSuccess={console.log}
                class=""
                iconOnly={false}
                shape="square"
                text={t`Connect to enable P2P`}
            />
        </div>
    }

    const {link, error} = useP2PIframe(defaultPage);
    if (error != null)
        return <div class="h-full w-full min-h-[inherit]">
            {/* OOPS */}
        </div>

    if (link == null)
        return;
    
    return <div class="h-full w-full min-h-[inherit]">
        <iframe class="h-full w-full min-h-[inherit]" src={link} />
    </div>
}